export default __webpack_public_path__ + "static/media/job-list-empty-state.8af5ae17.png";